import type { DetailItemCardsProps } from "./types-detail-item-cards";
import { DetailItemCardsView } from "./view-detail-item-cards";

export function DetailItemCards(props: DetailItemCardsProps) {
  return <DetailItemCardsView {...props} />;
}

export type * from "./types-detail-item-cards";
